import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { FuseLoadingBarComponent } from '@fuse/component/loading-bar/loading-bar.component';
import { FuseProgressBarService } from '@fuse/service/progress-bar.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FuseLoadingBarComponent, NgIf],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly progressBarService = inject(FuseProgressBarService);
  protected readonly showLoadingBar = computed(() => this.progressBarService.visible());
}
